import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ChevronRight } from 'lucide-react';
import { useJsonLd } from '../services/seo';
import { useT } from '../services/i18n';

// items: [{ label, to }] — last item is the current page (no link). Emits BreadcrumbList JSON-LD.
const Breadcrumb = ({ items, testId = 'breadcrumb' }) => {
  const { t } = useT();
  const all = [{ label: t('common.home'), to: '/' }, ...items.filter(Boolean)];
  // Google requires `item` on every ListItem except the last: unlinked intermediate labels are left out of the JSON-LD
  const ldItems = all.filter((it, i) => it.to || i === all.length - 1);
  useJsonLd('breadcrumb', {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: ldItems.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.label,
      item: `${window.location.origin}${i === ldItems.length - 1 ? window.location.pathname : it.to}`,
    })),
  });

  return (
    <nav aria-label={t('common.breadcrumb')} className="mb-6" data-testid={testId}>
      <ol className="flex items-center gap-1.5 text-sm text-gray-500 flex-wrap">
        {all.map((it, i) => {
          const last = i === all.length - 1;
          return (
            <li key={`${it.label}-${i}`} className="flex items-center gap-1.5 min-w-0">
              {i > 0 && <ChevronRight size={14} className="text-gray-300 flex-shrink-0" />}
              {last || !it.to ? (
                <span className="text-gray-800 font-medium truncate max-w-[60vw] sm:max-w-md" aria-current="page" data-testid={`${testId}-current`}>{it.label}</span>
              ) : (
                <Link to={it.to} data-testid={`${testId}-link-${i}`} className="flex items-center gap-1 text-blue-600 hover:text-orange-600 hover:underline transition-colors">
                  {i === 0 && <Home size={14} />}
                  {it.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
